import React from "react"
import { Row, Col, Card, Typography } from "@visa/vds"
import VstsSubcriptionsAccordion from "./VstsSubcriptionsAccordion"
import ApprovedProductsAccordion from "./ApprovedProductsAccordion"
import CertificationPackagesAccordion from "./CertificationPackagesAccordion"

const ProductCertificationCard = (props) => {
    return (
        <>
            <Row>
                <Col className="margin-bottom-zero padding-left-0px color-navy">
                    <Typography className="margin-bottom-zero" tag="h2" variant="title" id="product_certification_title">Product Certification</Typography>
                </Col>
            </Row>
            <Card className="width-full card-dashboard blue-left-line margin-bottom-30px card-shadow ">
                <ApprovedProductsAccordion
                    selectedBid={props.selectedBid}
                    setPageError={props.setPageError}
                />
                <CertificationPackagesAccordion
                    selectedBid={props.selectedBid}
                    setPageError={props.setPageError}
                />
                <VstsSubcriptionsAccordion
                    selectedBid={props.selectedBid}
                    setPageError={props.setPageError}
                />

            </Card>
        </>
    )
}

export default ProductCertificationCard